// Leftovers from the removed old offer: the theme still calls these after cart changes
window.updatedFreeProduct = window.updatedFreeProduct || function () {};

// Rebuild the "You'll Also Love" slider after the drawer HTML is replaced
window.ReBuildSlider = window.ReBuildSlider || function () {
  if (typeof jQuery === 'undefined') return;
  const $s = jQuery('.upselles_container');
  if (!$s.length) return;
  if ($s.hasClass('slick-initialized')) $s.slick('unslick');
  $s.slick({ slidesToShow: 1, slidesToScroll: 1, infinite: true });
};

$(document).ready(function(){
  //BO Quick add to cart on mobile
  $('.cart-quick-view').click(function(){
    $(this).addClass('hide');
    $(this).next('.quick_add_container').css({'opacity': 1,'visibility': 'visible'});
    $(this).prev('.quick-view-close').removeClass('hide');
  });
  $('.quick-view-close').click(function(){
    $(this).addClass('hide');
    $(this).next().next('.quick_add_container').css({'opacity': 0,'visibility': 'hidden'});
    $('.cart-quick-view').removeClass('hide');
  });
  //EO Quick add to cart on mobile
    $(".upselles_container").slick({
      //arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      // centerMode: true,
      // centerPadding: '40px'
     });
 $('.collection-slider-container').each(function () {
  let $container = $(this);
  let slidesToShow = $container.data('slide-show');
  let slidesToShowTab = $container.data('slide-show-tab');
  let slidesToShowMb = $container.data('slider_to_show_on_mb');

  $container.find('.collection-slider').slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    draggable: true,
    nextArrow: '<div class="next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
    prevArrow: '<div class="prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowTab,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slidesToShowMb,
          slidesToScroll: 1,
          infinite: false
        }
      }
    ]
  });
});



 $('.notification-carousel').slick( {
       autoplay:true,
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows: false,
       adaptiveHeight: true, 
    }, true);   
  
var variantSubmitButtons = document.querySelectorAll('.variant-submit');


// Add click event listener to each 'variant-submit' button
   variantSubmitButtons.forEach(function(button) {
       button.addEventListener('click', function() {
     
        var selected_var = button.getAttribute('data-id');
        // console.log('selected-var',selected_var);
        var productCard = button.closest('.product');
        var addButton = productCard.querySelector('.quick_add_active .add_to_cart_button');
        addButton.setAttribute('data-id', selected_var);
        addButton.setAttribute('data-product-id', selected_var);
        addButton.click();
    });
});

  
  
  let name = $('.product-section .product .product-information .product_title').text();
  let parts = name.split('-');
  let newName = parts[0].trim();
  let encodedTitle = encodeURIComponent(newName);
  let url = 'https://levatelabel.com/search?q=' + encodedTitle + '&options%5Bprefix%5D=last&view=product-filter';
    url = window.Shopify.routes.root + "search/suggest.json?q="+encodedTitle+"&resources[type]=product&resources[options][unavailable_products]=show"
   $.ajax({
        type: 'GET',
        url: url, 
        dataType: 'json',
        success: function(res) {
          const data = res.resources.results.products;
          let productsHTML = '';
           data.forEach(function(product) {
             let image = product.featured_image;
             let productTitle = product.title;
             let getColour = productTitle.split('-');

             // let getColour = productTitle.split(/-(?=[^-]*$)/);

             let wordAfterHyphen = getColour.length > 1 ? getColour[1].trim() : '';
             let classNamefirst = wordAfterHyphen.replace(/\s+/g, "-");
             let productHandle = product.handle;
             if (productTitle.includes(newName)) {
                 let productHTML = '<div class="link_with_image">';
                 productHTML += '<a href = "https://levatelabel.com/products/'+productHandle+'" class="'+classNamefirst.toLowerCase()+'" data-proTitle = "' + productTitle + '" ></a>';
                 productHTML += '</div>';
                 productsHTML += productHTML;
               }
             $('.image_product').html(productsHTML);
            });
            console.log('productsHTML', productsHTML)
            if (!name.includes("-")) {
              //$('.related_product_container').hide();
            }
            $('.link_with_image').each(function() {
            let color= $(this).find('a').attr('data-proTitle').trim();
            if (color == name.trim()) {
              $(this).addClass('matching-color');
            }
        });
        }

});

$('.product').each(function(index) {
    let nameCollection = $(this).find('h3').find('a').text().trim();
    // console.log('nameCollection', nameCollection, index)
    // let partCollection = nameCollection.split('-');
    let partCollection = nameCollection.split(/-(?=[^-]*$)/);
    let newCollectionName = partCollection[0].trim();
    let encodedTitle = encodeURIComponent(newCollectionName);
    let $imageProductCollection = $(this).find('.image_product_collection');
    console.log('encodedTitle', encodedTitle);
    let url = 'https://levatelabel.com/search?q=' + encodedTitle + '&options%5Bprefix%5D=last&view=product-filter';
    url = window.Shopify.routes.root + "search/suggest.json?q="+encodedTitle+"&resources[type]=product&resources[options][unavailable_products]=show"
    $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: function(res) {
          const collectionData = res.resources.results.products;
          console.log('collectionData', collectionData, encodedTitle)
            let productsHTML = '';
            collectionData.forEach(function(product) {
                let productTitle = product.title;
                let productHandle = product.handle;
                // let setColour = productTitle.split('-');
                let setColour = productTitle.split(/-(?=[^-]*$)/);
                // console.log('setColour', setColour, index)
                if (setColour.length == 2) {
                  let wordHyphen = setColour[1].trim();
                  // console.log(wordHyphen ,'wordHyphen');
                  let className = wordHyphen.replace(/\s+/g, "-");
                  //console.log(className);
                  // console.log('consd', productTitle, newCollectionName, nameCollection,index, setColour)
                  if (productTitle.includes(newCollectionName)) {
                      let productHTML = '<div class="link_with_image_collection">';
                      productHTML += '<a href="https://levatelabel.com/products/' + productHandle + '" data-proTitle="' + productTitle + '" class="'+className.toLowerCase()+'"></a>';
                      productHTML += '</div>';
                      productsHTML += productHTML;
                  }
                }
              // console.log(productsHTML,'productsHTML');
            $imageProductCollection.html(productsHTML);
            });
            $imageProductCollection.find('.link_with_image_collection').each(function() {
                let color = $(this).find('a').attr('data-proTitle').trim();
                let productName = $(this).closest('.product').find('h3').find('a').text().trim();
                if (color == productName) {
                    $(this).addClass('matching-color');
                }
            });
        }
    });
 });


// $(document).on('click', '.upsell-add-to-cart', function() {
   
//     var selected_var = $(this).attr('data-variant-id');
//     console.log(selected_var);
    
//     // Find the corresponding .quick_add_active .add_to_cart_button based on the position within the container
//     var addButton = $(this).closest('.upsell-data-container').find('.quick_add_active .add_to_cart_button');
    
//     console.log(addButton);
//     addButton.attr('data-id', selected_var);
//     addButton.attr('data-product-id', selected_var);
 
//     // let body = document.querySelector('.quick_add_active .add_to_cart_button');
//     // body.dispatchEvent(new Event('click'));
// });

  



  function productImage(){
          $('.product-images:not(.slick-initialized)').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
          nextArrow: '<div class="next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></div>',
          prevArrow: '<div class="prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98" width="20px" height="20px"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg> </div>'
        });
  }
  
 
  if ($(window).width() < 768) {
     productImage();
  }

 $(window).resize(function() {
     if ($(window).width() < 768) {
       productImage()
     }
 })
      let h = document.querySelector('.header-scrolling-bar .scrolling-text').offsetHeight;
    console.log('height',h);
    document.documentElement.style.setProperty('--scrolling-height', h + 'px');
});


document.addEventListener('cart-drawer:close', function() {
  console.log('cart-drawer:close');
  document.body.style.overflow = 'auto'
})
document.addEventListener('cart-drawer:before-open', function() {
  console.log('cart-drawer:before-open')
  document.body.style.overflow = 'hidden'
})

// Lightbox Issue 
document.addEventListener('DOMContentLoaded', function () {
  var pswpEl = document.querySelector('.pswp');
  if (!pswpEl) return;

  var observer = new MutationObserver(function () {
    var isClosed = pswpEl.getAttribute('aria-hidden') === 'true';
    var stillBlockingTouch = pswpEl.classList.contains('pswp--open');

    if (isClosed && stillBlockingTouch) {
      pswpEl.classList.remove('pswp--open', 'pswp--visible', 'pswp--animated-in');
      pswpEl.style.display = 'none';
    }
  });

  observer.observe(pswpEl, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
});

// Free Gift - Cart Drawer
(() => {
  const nativeFetch = window.fetch.bind(window);
  const MUTATION_URL = /\/cart\/(add|change|update|clear)/;
  const CARTJS_URL = /\/cart\.js(\?|$)/;
  const DRAWER_SECTION = 'free-gift-drawer';
  const SECTIONS = 'free-gift-drawer,cart-bubble';
  const CHECKOUT_SEL =
    '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .additional-checkout-buttons';
  const root = document.documentElement;

  let running = null;
  let dirty = false; // a cart change finished while a sync was running
  let known = null; // { cart, at } newest full cart seen
  let lastChange = 0; // when the latest cart change finished
  let waiters = [];
  let timer = null;
  const cartJsInflight = new Set();

  // gift variants whose add was rejected (sold out) during this page session
  const soldOut = new Set();

  // checkout lock state
  let inflight = 0; // cart change requests in flight
  let prelock = 0; // short lock between a click and its request starting
  let prelockTimer;
  let lockOverride = false; // failsafe: never keep customers locked out
  let failsafe;
  let lockedNow = false;

  const log = (...a) => window.fgDebug && console.log('[free-gift]', ...a);

  // Only a real cart object counts (add.js responses only describe the added line)
  const isFullCart = (c) =>
    c && Array.isArray(c.items) && typeof c.item_count === 'number' && typeof c.total_price === 'number';

  // Every configured tier is listed, with `available` telling whether the gift is in stock.
  // Sold-out tiers stay in the list so a gift already in the cart can still be removed.
  const getTiers = () => {
    const seen = new Set();
    return [...document.querySelectorAll('free-gift [data-gift-tier]')]
      .map((el) => ({
        key: el.dataset.key,
        min: parseInt(el.dataset.min, 10),
        variant: parseInt(el.dataset.variant, 10),
        available: el.dataset.available !== 'false',
      }))
      .filter((t) => !seen.has(t.key) && seen.add(t.key));
  };

  // ---------- checkout lock ----------
  const isBusy = () =>
    !lockOverride && (inflight > 0 || prelock > 0 || !!running || !!timer);

  function updateLock() {
    const locked = isBusy() && getTiers().length > 0;
    if (locked === lockedNow) return;
    lockedNow = locked;

    if (locked) root.setAttribute('data-fg-locked', '');
    else root.removeAttribute('data-fg-locked');

    clearTimeout(failsafe);
    if (locked) {
      failsafe = setTimeout(() => {
        lockOverride = true;
        updateLock();
      }, 8000);
    }
  }

  function beginChange() {
    inflight++;
    lockOverride = false;
    updateLock();
  }

  function endChange(sync) {
    inflight = Math.max(0, inflight - 1);
    if (sync) queueSync();
    updateLock();
  }

  // Lock as soon as remove / plus / minus is pressed, before the request starts
  document.addEventListener(
    'click',
    (e) => {
      if (!e.target.closest('.stepper-btn, .mini_cart_item .remove')) return;
      prelock = 1;
      lockOverride = false;
      updateLock();
      clearTimeout(prelockTimer);
      prelockTimer = setTimeout(() => {
        prelock = 0;
        updateLock();
      }, 700);
    },
    true
  );

  // Block checkout clicks (including keyboard activation) while locked
  document.addEventListener(
    'click',
    (e) => {
      if (!lockedNow) return;
      if (e.target.closest(CHECKOUT_SEL)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // ---------- cart tracking ----------
  const hasFreshInflight = () => [...cartJsInflight].some((r) => r.t >= lastChange);

  function settleWaiters(cart) {
    const w = waiters;
    waiters = [];
    w.forEach((fn) => fn(cart));
  }

  function remember(cart, at) {
    if (!isFullCart(cart)) return;
    if (!known || at >= known.at) known = { cart, at };
    if (at >= lastChange) settleWaiters(cart);
  }

  // Track the theme's own cart.js requests so their result can be reused
  function trackCartJs() {
    const rec = { t: Date.now() };
    cartJsInflight.add(rec);
    return (cart) => {
      cartJsInflight.delete(rec);
      remember(cart, rec.t);
      // nothing fresh left to wait for: let waiters fetch the cart themselves
      if (waiters.length && !hasFreshInflight()) settleWaiters(null);
    };
  }

  function changeFinished(data) {
    lastChange = Date.now();
    remember(data, lastChange);
  }

  // Get a cart that reflects the latest change, with as few requests as possible
  async function getCart() {
    if (known && known.at >= lastChange) return known.cart;

    // give the theme a moment to start its own cart.js, then reuse it
    await new Promise((r) => setTimeout(r, 30));
    if (known && known.at >= lastChange) return known.cart;

    if (hasFreshInflight()) {
      const c = await new Promise((res) => {
        const to = setTimeout(() => res(null), 3000);
        waiters.push((cart) => {
          clearTimeout(to);
          res(cart);
        });
      });
      if (c) return c;
    }

    const started = Date.now();
    const cart = await (await nativeFetch('/cart.js')).json();
    remember(cart, started);
    return cart;
  }

  // Swap the new drawer in, keep the existing upsell node, refresh the cart count,
  // and re-bind the theme's button handlers on the new markup
  function applyDrawerHtml(sections) {
    const parse = (html, sel) =>
      new DOMParser().parseFromString(html, 'text/html').querySelector(sel);

    const fresh = parse(sections[DRAWER_SECTION], '#Cart-Drawer .side-panel-content');
    const current = document.querySelector('#Cart-Drawer .side-panel-content');
    if (!fresh || !current) return;

    // Keep the existing upsell node (and its slider)
    const oldUpsell = current.querySelector('.upsell:not([data-fg-slot])');
    if (oldUpsell) oldUpsell.remove();

    current.innerHTML = fresh.innerHTML;

    const slot = current.querySelector('.upsell[data-fg-slot]');
    if (slot && oldUpsell) slot.replaceWith(oldUpsell);
    else if (slot) slot.remove();

    // Header cart count
    if (sections['cart-bubble']) {
      const toggle = document.getElementById('cart-drawer-toggle');
      const target = toggle && (toggle.querySelector('.float_count') || toggle);
      const freshBubble = parse(sections['cart-bubble'], '.float_count');
      if (target && freshBubble) target.innerHTML = freshBubble.innerHTML;
    }

    // The theme binds these to the buttons directly, so bind them on the new markup
    const inst = window._cartDrawerInstance;
    if (inst) {
      inst.removeProductEvent();
      inst.notesToggle();
      inst.termsCheckbox();
    }

    document.dispatchEvent(new CustomEvent('free-gift:updated'));
  }

  async function doSync() {
    const tiers = getTiers();
    if (!tiers.length) return;
    const t0 = performance.now();

    try {
      const cart = await getCart();
      const giftVariants = new Set(tiers.map((t) => t.variant));

      // Paid items only, so gifts never count toward their own threshold
      const paidTotal = cart.items
        .filter((i) => !giftVariants.has(i.variant_id))
        .reduce((sum, i) => sum + i.final_line_price, 0);

      // Only in-stock tiers can be given; the highest one the customer qualifies for wins
      const sellable = tiers.filter((t) => t.available && !soldOut.has(t.variant));
      const qualifying = sellable
        .filter((t) => paidTotal > t.min)
        .sort((a, b) => b.min - a.min)[0];
      const activeVariant = qualifying ? qualifying.variant : null;

      // A sold-out tier is never the active one, so a gift line of that variant gets removed
      const updates = {};
      tiers.forEach((t) => {
        const line = cart.items.find((i) => i.variant_id === t.variant);
        const shouldHave = t.variant === activeVariant;
        if (shouldHave && (!line || line.quantity !== 1)) updates[t.variant] = 1;
        else if (!shouldHave && line) updates[t.variant] = 0;
      });

      if (!Object.keys(updates).length) {
        log('no change needed', Math.round(performance.now() - t0) + 'ms');
        return;
      }

      // One request: remove + add + get the re-rendered drawer back
      const res = await nativeFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates, sections: SECTIONS }),
      });
      if (!res.ok) {
        console.error('Free gift update failed', await res.text());
        // Shopify rejects the whole update if a gift is out of stock:
        // mark those gifts as sold out and run the sync again
        if (res.status === 422) {
          const adds = Object.keys(updates).filter((id) => updates[id] > 0);
          if (adds.length) {
            adds.forEach((id) => soldOut.add(parseInt(id, 10)));
            dirty = true;
          }
        }
        return;
      }
      const data = await res.json();
      changeFinished(data); // our own swap result is the newest cart
      log('gift swap', Math.round(performance.now() - t0) + 'ms');

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else if (data.sections && data.sections[DRAWER_SECTION]) {
        applyDrawerHtml(data.sections);
      } else {
        const s = await (await nativeFetch('/?sections=' + SECTIONS)).json();
        if (s[DRAWER_SECTION]) applyDrawerHtml(s);
      }
    } catch (e) {
      console.error('Free gift sync failed', e);
    }
  }

  function syncGifts() {
    if (running) {
      dirty = true; // cart changed mid-sync: run once more afterwards
      return running;
    }
    running = (async () => {
      do {
        dirty = false;
        await doSync();
      } while (dirty);
    })().finally(() => {
      running = null;
      updateLock();
    });
    updateLock();
    return running;
  }

  function queueSync() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      syncGifts();
    }, 0);
    updateLock();
  }

  // fetch: watch cart changes and cart.js, pass everything else straight through
  window.fetch = async (...args) => {
    const first = args[0];
    const url = typeof first === 'string' ? first : (first && (first.url || first.href)) || '';
    const isChange = MUTATION_URL.test(url);
    const isCartJs = CARTJS_URL.test(url);
    if (!isChange && !isCartJs) return nativeFetch(...args);

    const done = isCartJs ? trackCartJs() : null;
    if (isChange) beginChange();

    let res;
    try {
      res = await nativeFetch(...args);
    } catch (e) {
      if (done) done(null);
      if (isChange) endChange(false);
      throw e;
    }

    res
      .clone()
      .json()
      .catch(() => null)
      .then((data) => {
        if (done) done(data);
        if (isChange) {
          if (res.ok) {
            changeFinished(data);
            endChange(true);
          } else {
            endChange(false);
          }
        }
      });
    return res;
  };

  // XHR / jQuery $.ajax
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  const parseXhr = (x) => {
    try {
      if (!x.responseType || x.responseType === 'text') return JSON.parse(x.responseText);
      if (x.responseType === 'json') return x.response;
    } catch (e) {}
    return null;
  };
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._fgUrl = String(url);
    return origOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    const url = this._fgUrl || '';
    const isChange = MUTATION_URL.test(url);
    const isCartJs = CARTJS_URL.test(url);
    if (isChange || isCartJs) {
      const done = isCartJs ? trackCartJs() : null;
      if (isChange) beginChange();
      this.addEventListener('loadend', () => {
        const data = parseXhr(this);
        if (done) done(data);
        if (isChange) {
          if (this.status >= 200 && this.status < 300) {
            changeFinished(data);
            endChange(true);
          } else {
            endChange(false);
          }
        }
      });
    }
    return origSend.apply(this, args);
  };

  window.freeGiftSync = syncGifts; // manual trigger for debugging
})();
